// Typelizer digest b606ede80d9f72f9fccfafaa78b993be
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../../runtime'
import { buildUrl } from '../../runtime'

export default {
  /** PATCH /c/:company_id/ledger/vat_settings */
  update: (options?: RouteOptions): RouteDefinition<'patch'> => ({
    url: buildUrl('/c/:company_id/ledger/vat_settings', {}, options),
    method: 'patch',
  }),
}
